export class EnaioResource {
    resourceId: string;
    resourceName: string;
    type = 0;
    description: string;
    maxPreserve = 0;
    serverGroupId = 0;
}
